import { render } from "./SwapPublicationSuccess.vue?vue&type=template&id=788592f1&scoped=true"
import script from "./SwapPublicationSuccess.vue?vue&type=script&lang=js"
export * from "./SwapPublicationSuccess.vue?vue&type=script&lang=js"

import "./SwapPublicationSuccess.vue?vue&type=style&index=0&id=788592f1&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788592f1"]])

export default __exports__